






































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";

@Component({
  name: "request-spaces-container",
})
export default class RequestSpacesComponent extends mixins(NotificationEvent) {
  isEvent = false;
  currentPage = 1;
  itemsPerPage = 30;
  lastPage = 1;
  loader = false;
  search = "";
  requests = [];
  timeout = null;

  mounted() {
    this.getSpacesReqeuest();
  }
  @Watch("currentPage")
  updatePage(): void {
    this.getSpacesReqeuest();
  }
  @Watch("optionSelected")
  updateOptionSelected(): void {
    if (this.currentPage == 1) this.getSpacesReqeuest();
    else this.currentPage = 1;
  }
  @Watch("search")
  updateoSearch(): void {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (this.currentPage == 1) this.getSpacesReqeuest();
      else this.currentPage = 1;
      this.timeout = null;
    }, 1000);
  }
  /*getUsers(): void {
    const space = !this.$route.params.space
      ? this.$store.getters["SpaceStore/getSpace"]
      : this.$route.params.space;
    this.loader = true;
    this.$store.dispatch("SpaceStore/getUsersAction", {
      spaceId: space.id,
      page: this.currentPage,
      search:
        this.search != ""
          ? "&search=" +
            this.search
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
          : "",
      permissions: this.getPermisions(),
      callback: (response) => {
        this.auxUsers = response.data;
        this.lastPage = parseInt(response.headers["pagination-last-page"]);
        this.itemsPerPage = parseInt(
          response.headers["pagination-items-per-page"]
        );
        this.loader = false;
      },
      callbackError: (error) => {
        this.loader = false;
        this.onError(
          this.$i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry"),
          "none"
        );
      },
    });
  }
*/
  getSpacesReqeuest() {
    this.$store.dispatch("SpaceStore/getRequestSpacesAction", {
      page: this.currentPage,
      callback: (response) => {
        this.requests = response.data;
        this.lastPage = parseInt(response.headers["pagination-last-page"]);
        this.itemsPerPage = parseInt(
          response.headers["pagination-items-per-page"]
        );
        this.loader = false;
      },
    });
  }
  copy(url): void {
    const cb = navigator.clipboard;
    cb.writeText(url).then(() =>
      this.onDefault("", this.$i18n.t("notifications.descriptions.copyUrl"))
    );
  }
}
